export enum ProductTableColumns {
  ProductName = 0,
  Quantity = 1,
  Price = 2,
  Vat = 3,
  Total = 4
}
